import React, { Fragment, useState, useReducer } from "react";
import { Button, Dropdown, Modal, Tab, Nav } from "react-bootstrap";
import { GlobalSet } from '../../global/GlobalProvider';
import { Link ,useHistory} from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import axios from "axios";
import { useEffect } from 'react';
import swal from "sweetalert";
//** Import Image */
import profile from "../../../../images/DemoIm.png";
import rank from "../../../../images/icon/rank.png";
import PageTitle from "../../../layouts/PageTitle";
//lg
import { useTranslation, initReactI18next } from 'react-i18next';
import i18n from 'i18next';

const initialState = false;
const reducer = (state, action) =>{
	switch (action.type){
		case 'sendMessage':
			return { ...state, sendMessage: !state.sendMessage }		
		case 'postModal':
			return { ...state, post: !state.post }
		case 'linkModal':
			return { ...state, link: !state.link }		
		case 'cameraModal':
			return { ...state, camera: !state.camera }		
		case 'replyModal':
			return { ...state, reply: !state.reply }
		default:
			return state	
	}	
}


  const AppProfile = () => {
  const { CurrencySymbol } = GlobalSet();
  const { BaseUrl } = GlobalSet();
	const [SetYouImg, AYouImage] = useState(null)
	const [loading, setLoading] = useState(false);
	const [ggs_photo, ApiYouImage] = useState([]);
  const { t } = useTranslation();
  
	const [errorlist, setErrors] = useState([]);
	const [showText, setShowText] = useState(false);
  const [user, setUser] = useState([]);
    useEffect(()=>{
    	const auth_token = localStorage.getItem('auth_token');
    	const selectedCurrency = localStorage.getItem('selectedCurrency');
        const data = {
            key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
            currency: selectedCurrency,
        }
    	if (auth_token !== null) {
    		 axios.post('/apps-profile',data)
       	 .then(response=>{
           setUser(response.data)
           console.log(response.data)
           
			     })
			     .catch(error=>{
			       console.log(error)
			   })
    	}

    },[])


  const submitProduct=(e) =>{
  	if(!loading){
 	  setLoading(true);
      e.preventDefault();
      const formData= new FormData();
      formData.append('key_s', "eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9");
      formData.append('your_image', ggs_photo.your_image);
      axios.post('/change-profile-photo', formData)
      .then((res)=>{
  	  setLoading(false);
            if(res.data.status === 'success')
            {
                swal("Success",res.data.message,"success");
            }
           else if(res.data.status === 'fail')
            {
                swal("Warning",res.data.message,"warning");
            }
            else
            {
                setRegister({...registerInput, error_list: res.data.validation_error});
            }
     		setLoading(false);
        setShowText(false);
      });
	}
  }


  const [registerInput, setRegister] = useState({
    your_image:'',
      error_list: [],
  });

	const YourImage = (event) => {
	 if (event.target.files && event.target.files[0]) {
	   AYouImage(URL.createObjectURL(event.target.files[0]));
	   ApiYouImage({your_image: event.target.files[0] });
	   setShowText(true);
	 }
	}



	let packageLabel;
	let Email;
	let picture_Url;
	let mobile_No;
	let address;
	let name;
	let last_name;
	let createdat;
	let reference_code;
	let balance;
	let bonus_balance;
	let total_deposit;
	let total_Income;
	let total_withdraw;
	let affiliate_earning;
	let active_status;
	let username;
	let level_increment;
	let clubstatus;
	let investAmount;
	if (user == "") {
		console.log(user);
	}else{

		if(user.data.picture_Url === '0'){
			picture_Url = profile;
		}else{
			picture_Url = BaseUrl+user.data.picture_Url;
		}
		Email=user.data.email;
		createdat=user.data.created_at;
		name=user.data.name;
		username=user.data.username;
		last_name=user.data.last_name;
		mobile_No=user.data.mobile_No;
		address=user.data.address;
		reference_code=user.data.reference_code;
		balance=user.data.balance;
		bonus_balance=user.data.bonus_balance;
		total_deposit=user.data.total_deposit;
		total_Income=user.data.total_Income;
		total_withdraw=user.data.total_withdraw;
		affiliate_earning=user.data.affiliate_earning;
		active_status=user.data.active_status;
		level_increment=user.data.level_increment;
		clubstatus=user.data.clubstatus;
		investAmount=user.data.total_invest;


	  if (investAmount >= 100) {
	    packageLabel = 'Standard Package';
	  } else {
	    packageLabel = 'General Package';
	  }



	}

	const rankMap = {
	  0: 'User',
	  1: 'Associate',
	  2: 'Executive Associate',
	  3: 'Senior Executive',
	  4: 'Team Leader',
	  5: 'Senior Team Leader',
	  6: 'Manager',
	  7: 'Senior Manager',
	  8: 'Director',
	  9: 'Regional Director',
	  10: 'National Director',
	  11: 'Vice President',
	  12: 'Senior Vice President',
	  13: 'Crown Leader',
	  14: 'Royal Ambassador',
	  15: 'Global Master',
	};	
		
	const options = {
	  settings: {
	    overlayColor: "#000000",
	  },
	};

	const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <Fragment>
      <div className="row">
        <div className="col-lg-12">
          <div className="profile card card-body px-3 pt-3 pb-0">
            <div className="profile-head">
              <div className="photo-content ">
                <div className="cover-photo rounded"></div>
              </div>
              <div className="profile-info">
                <div className="profile-photo">
						<form onSubmit={submitProduct} enctype= "multipart/form-data">
                <div className="profile-photo">
				        <i className="fa fa-edit" style={{ cursor: "pointer" }}>
				            <input 
				                type="file" 
				                id="formFile" 
				                name="your_image"
				                onChange={YourImage}
				                style={{
				                    position: "absolute",
				                    opacity: 0,
				                    width: "100%",
				                    height: "100%",
				                    left: 0,
				                    top: 0,
				                    cursor: "pointer"
				                }}
				            />
				        </i>

                  <img
                    src={SetYouImg || picture_Url || profile}
                    className="img-fluid rounded-circle"
                    alt="profile"
                  />
                </div>
            {showText && (
						<button type="submit" className="btn btn-primary sw-btn-next ms-1 mt-1">{loading ? t('Submitting') : t('Submit')}</button>
            )}	                
            </form>
                </div>
                <div className="profile-details">
                  <div className="profile-name px-3 pt-2">
                    <h4 className="mb-0">  {t('pro_pg_username')} : <b>{username}  </b> </h4>
                    {/* <p>{t('pro_pg_username')}</p> */}
                  </div>

                  <div className="profile-name px-3 pt-2 mb-2">
                    <h4 className="mb-0"> {t('pro_pg_ref_cd')} : <b> {reference_code}  </b> </h4>
                    {/* <p>{t('pro_pg_ref_cd')}</p> */}
                  </div>

                

										<div className="profile-name px-3 pt-2">
										  <button
										    className={`btn btn-lg btn-block ${active_status === 1 ? 'btn-success' : 'btn-warning'}`}
										    type="submit"
										  >
										    {active_status === 1 ? 'Active' : 'Inactive'}
										  </button>
										</div>

										<div className="profile-name px-3 pt-2">

										    <h3 style={{ color: '#464a53' }} className="flex items-center gap-2"> Rank:  
												<img
												  src={`${BaseUrl}public/basic_icon/rank${clubstatus}.png`}
												  alt="Main Wallet"
												  width="60"
												  height="50"
												  onError={(e) => { e.currentTarget.src = rank; }}
												/>

										     {rankMap[clubstatus] ?? 'Unknown'}</h3>
								
										</div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



						<div className="col-xl-12">
							<div className="row">
							<div className="col-xl-3 col-sm-6">
									<div className="card booking">
										<div className="card-body">
											<div className="booking-status d-flex align-items-center">
                          <img 
                            src={BaseUrl+"public/basic_icon/asset_main_wallet.png"} 
                            alt="Main Wallet" 
                            width="60"
                            height="50"
                          />
												<div className="ms-4">
													<h4 className="mb-0 font-w600">{"$"+ total_withdraw}</h4>
													<b> <p className="mb-0">{t('pro_pg_tot_wit')}</p> </b>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-xl-3 col-sm-6">
									<div className="card booking">
										<div className="card-body">
											<div className="booking-status d-flex align-items-center">
                        <img 
                          src={BaseUrl+"public/basic_icon/asset_deposit_wallet.png"} 
                          alt="Deposit Wallet" 
                          width="60"
                          height="50"
                        />
												<div className="ms-4">
													<h4 className="mb-0 font-w600">{"$"+ balance}</h4>
													<b><p className="mb-0 text-nowrap">{t('pro_pg_curr_bal')}</p> </b>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-xl-3 col-sm-6">
									<div className="card booking">
										<div className="card-body">
											<div className="booking-status d-flex align-items-center">
                        <img 
                          src={BaseUrl+"public/basic_icon/asset_Total_Income.png"} 
                          alt="Total Income Icon" 
                          width="60"
                          height="50"
                        />
												<div className="ms-4">
													<h4 className="mb-0 font-w600">{"$"+ total_Income}</h4>
													<b> <p className="mb-0">{t('pro_pg_tot_inc')}</p> </b>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-xl-3 col-sm-6">
									<div className="card booking">
										<div className="card-body">
											<div className="booking-status d-flex align-items-center">
                          <img 
                            src={BaseUrl+"public/basic_icon/asset_total_deposit.png"} 
                            alt="Total Deposit Icon" 
                            width="60"
                            height="50"
                          />
												<div className="ms-4">
													<h4 className="mb-0 font-w600">{"$"+ total_deposit}</h4>
													<b>  <p className="mb-0 text-nowrap ">{t('pro_pg_tot_dep')}</p> </b>
												</div>
											</div>
										</div>
									</div>
								</div>
								
								
							</div>
						</div>

 {/* <div className="col-xl-12">
  <div className="row"> 
    <div className="col-xl-3 col-sm-6">
      <div className="card booking" style={{ border: '1px solid #e0e0e0', borderRadius: '12px', boxShadow: '0 2px 12px rgba(0,0,0,0.05)', padding: '20px' }}>
        <div className="card-body" style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ backgroundColor: '#f0f8ff', padding: '10px', borderRadius: '50%' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="20" viewBox="0 0 28 20">
              <path d="M27,14V7a1,1,0,0,0-1-1H6A1,1,0,0,0,5,7v7a3,3,0,0,0-3,3v8a1,1,0,0,0,2,0V24H28v1a1,1,0,0,0,2,0V17A3,3,0,0,0,27,14ZM7,8H25v6H24V12a2,2,0,0,0-2-2H19a2,2,0,0,0-2,2v2H15V12a2,2,0,0,0-2-2H10a2,2,0,0,0-2,2v2H7Zm12,6V12h3v2Zm-9,0V12h3v2ZM4,17a1,1,0,0,1,1-1H27a1,1,0,0,1,1,1v5H4Z" transform="translate(-2 -6)" fill="var(--primary)" />
            </svg>
          </span>
          <div style={{ marginLeft: '15px' }}>
            <h4 style={{ margin: 0, fontWeight: '700', fontSize: '20px', color: '#333' }}>{"$" + balance}</h4>
            <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>{t('pro_pg_curr_bal')}</p>
          </div>
        </div>
      </div>
    </div>
 
    <div className="col-xl-3 col-sm-6">
      <div className="card booking" style={{ border: '1px solid #e0e0e0', borderRadius: '12px', boxShadow: '0 2px 12px rgba(0,0,0,0.05)', padding: '20px' }}>
        <div className="card-body" style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ backgroundColor: '#f0f8ff', padding: '10px', borderRadius: '50%' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="20" viewBox="0 0 28 20">
              <path d="M27,14V7a1,1,0,0,0-1-1H6A1,1,0,0,0,5,7v7a3,3,0,0,0-3,3v8a1,1,0,0,0,2,0V24H28v1a1,1,0,0,0,2,0V17A3,3,0,0,0,27,14ZM7,8H25v6H24V12a2,2,0,0,0-2-2H19a2,2,0,0,0-2,2v2H15V12a2,2,0,0,0-2-2H10a2,2,0,0,0-2,2v2H7Zm12,6V12h3v2Zm-9,0V12h3v2ZM4,17a1,1,0,0,1,1-1H27a1,1,0,0,1,1,1v5H4Z" transform="translate(-2 -6)" fill="var(--primary)" />
            </svg>
          </span>
          <div style={{ marginLeft: '15px' }}>
            <h4 style={{ margin: 0, fontWeight: '700', fontSize: '20px', color: '#333' }}>{"$" + total_deposit}</h4>
            <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>{t('pro_pg_tot_dep')}</p>
          </div>
        </div>
      </div>
    </div>
 
    <div className="col-xl-3 col-sm-6">
      <div className="card booking" style={{ border: '1px solid #e0e0e0', borderRadius: '12px', boxShadow: '0 2px 12px rgba(0,0,0,0.05)', padding: '20px' }}>
        <div className="card-body" style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ backgroundColor: '#f0f8ff', padding: '10px', borderRadius: '50%' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
              <path d="M129.035,178.842v2.8a5.6,5.6,0,0,0,5.6,5.6h14a5.6,5.6,0,0,0,5.6-5.6v-16.8a5.6,5.6,0,0,0-5.6-5.6h-14a5.6,5.6,0,0,0-5.6,5.6v2.8a1.4,1.4,0,0,0,2.8,0v-2.8a2.8,2.8,0,0,1,2.8-2.8h14a2.8,2.8,0,0,1,2.8,2.8v16.8a2.8,2.8,0,0,1-2.8,2.8h-14a2.8,2.8,0,0,1-2.8-2.8v-2.8a1.4,1.4,0,0,0-2.8,0Zm10.62-7-1.81-1.809a1.4,1.4,0,1,1,1.98-1.981l4.2,4.2a1.4,1.4,0,0,1,0,1.981l-4.2,4.2a1.4,1.4,0,1,1-1.98-1.981l1.81-1.81h-12.02a1.4,1.4,0,1,1,0-2.8Z" transform="translate(-126.235 -159.242)" fill="var(--primary)" fillRule="evenodd" />
            </svg>
          </span>
          <div style={{ marginLeft: '15px' }}>
            <h4 style={{ margin: 0, fontWeight: '700', fontSize: '20px', color: '#333' }}>{"$" + total_Income}</h4>
            <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>{t('pro_pg_tot_inc')}</p>
          </div>
        </div>
      </div>
    </div>
 
    <div className="col-xl-3 col-sm-6">
      <div className="card booking" style={{ border: '1px solid #e0e0e0', borderRadius: '12px', boxShadow: '0 2px 12px rgba(0,0,0,0.05)', padding: '20px' }}>
        <div className="card-body" style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ backgroundColor: '#f0f8ff', padding: '10px', borderRadius: '50%' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
              <path d="M151.435,178.842v2.8a5.6,5.6,0,0,1-5.6,5.6h-14a5.6,5.6,0,0,1-5.6-5.6v-16.8a5.6,5.6,0,0,1,5.6-5.6h14a5.6,5.6,0,0,1,5.6,5.6v2.8a1.4,1.4,0,0,1-2.8,0v-2.8a2.8,2.8,0,0,0-2.8-2.8h-14a2.8,2.8,0,0,0-2.8,2.8v16.8a2.8,2.8,0,0,0,2.8,2.8h14a2.8,2.8,0,0,0,2.8-2.8v-2.8a1.4,1.4,0,0,1,2.8,0Zm-10.62-7,1.81-1.809a1.4,1.4,0,1,0-1.98-1.981l-4.2,4.2a1.4,1.4,0,0,0,0,1.981l4.2,4.2a1.4,1.4,0,1,0,1.98-1.981l-1.81-1.81h12.02a1.4,1.4,0,1,0,0-2.8Z" transform="translate(-126.235 -159.242)" fill="var(--primary)" fillRule="evenodd" />
            </svg>
          </span>
          <div style={{ marginLeft: '15px' }}>
            <h4 style={{ margin: 0, fontWeight: '700', fontSize: '20px', color: '#333' }}>{"$" + total_withdraw}</h4>
            <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>{t('pro_pg_tot_wit')}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> */}



     {/* <div className="row">
        <div className="col-xl-4">

		</div>	
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="profile-tab">
                <div className="custom-tab-1">
					<Tab.Container defaultActiveKey='About'>					
						<Nav as='ul' className="nav nav-tabs mb-4">
							<Nav.Item as='li'i className="nav-item">
								<Nav.Link to="#about-me"  eventKey='About'>{t('pro_pg_ab_me')}</Nav.Link>
							</Nav.Item>
						</Nav>
						<Tab.Content>

							<Tab.Pane id="about-me" eventKey='About'>
								<div className="profile-personal-info">
									<h4 className="text-primary mb-4">
										Personal Information
									</h4>
									<div className="row mb-2">
										<div className="col-4">
											<h5 className="f-w-500"> {t('pro_pg_name')}:</h5>
										</div>
										<div className="col-8">
											<span>{name}</span>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-4">
											<h5 className="f-w-500"> Last Name:</h5>
										</div>
										<div className="col-8">
											<span>{last_name}</span>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-4">
											<h5 className="f-w-500">{t('pro_pg_email')}:</h5>
										</div>
										<div className="col-8">
											<span>{Email}</span>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-4">
											<h5 className="f-w-500">  {t('pro_pg_location')}:</h5>
										</div>
										<div className="col-8">
											<span>{address}</span>
										</div>
									</div>
								</div>
							</Tab.Pane>
						</Tab.Content>	
					</Tab.Container>		
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
<div className="row justify-content-center">
  <div className="col-xl-10">
    <div className="card border-0 shadow-sm rounded-4">
      <div className="card-body p-5">
        <div className="d-flex flex-column align-items-center text-center mb-4">
          <div className="mb-3">
            <img
              src={profile}
              className="img-fluid rounded-circle"
              alt="profile"
              width="60px"
            />
          </div>
          <h4 className="fw-bold text-dark mb-0">{name} {last_name}</h4>
          <p style={{ marginBottom: '0px' }}className="text-muted small">{Email}</p>
          <p className="text-muted small">Join Date: {createdat}</p>
        </div>

        <h5 className="text-primary fw-semibold mb-4 border-bottom pb-2 text-start">
          {t("pro_pg_ab_me")}
        </h5>

        <div className="row g-4">
          <div className="col-md-6">
            <div className="d-flex flex-column">
              <span className="text-muted small mb-1" style={{ fontSize: '20px' }}> <b> {t("pro_pg_name")} </b> </span>
              <span className="fw-medium text-dark">{name}</span>
            </div>
          </div>
          <div className="col-md-6">
            <div className="d-flex flex-column">
              <span className="text-muted small mb-1" style={{ fontSize: '20px' }}> <b> Last Name </b> </span>
              <span className="fw-medium text-dark">{last_name}</span>
            </div>
          </div>
          <div className="col-md-6">
            <div className="d-flex flex-column">
              <span className="text-muted small mb-1" style={{ fontSize: '20px' }}> <b> {t("pro_pg_email")} </b> </span>
              <span className="fw-medium text-dark">{Email}</span>
            </div>
          </div>
          <div className="col-md-6">
            <div className="d-flex flex-column">
              <span className="text-muted small mb-1" style={{ fontSize: '20px' }}> <b> {t("pro_pg_location")} </b> </span>
              <span className="fw-medium text-dark">{address}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


    </Fragment>
  );
};

export default AppProfile;
